<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-2 sdbr">
        <Sidebar />
      </div>
      <div class="col-sm-10 ap">
        <div class="row pt-1">
          <div class="col-sm-12">
            <i class="fa fa-angle-double-left" @click="setPrevRoute"></i>
          </div>
          <div class="col-sm-12 apittl text-center">Api Usage</div>
          <div class="col-sm-12 px-0 pt-2 text-right">
            <Timeframe v-on:timeFrameEmit="dateChanged" :filter="filterObj" />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">Total users : {{ filteredUsers.length }}</div>
        </div>
        <div class="row srchfilter d-flex justify-content-start">
          <div class="col-lg-3 searchbar">
            <input
              class="mt-1 form-control"
              type="search"
              aria-label="Search through site content"
              placeholder="Search Users"
              v-model="search"
            />
          </div>
          <div class="offset-sm-6"></div>
          <div class="d-none col-lg-3">
            <Paramdrpdwn
              v-on:sendParam="setSelected"
              :summaryParam="userStatus"
            />
          </div>
        </div>
        <div class="row" style="height: inherit; width: inherit">
          <div
            class="col-lg-12 listofdev border"
            style="height: 60vh; overflow-y: auto"
          >
            <table class="table table-list dev-table">
              <thead class="table ubuntu-medium">
                <tr>
                  <th scope="col">User</th>
                  <th scope="col" class="dropdown p-2">
                    Plan
                    <!-- <div > -->
                    <button
                      class="btn btn-sm dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                    ></button>
                    <ul class="dropdown-menu p-2">
                      <li @click="filterByPlan('all')">All</li>
                      <li @click="filterByPlan('free')">Free</li>
                      <li @click="filterByPlan('pay')">Pay as you go</li>
                      <li @click="filterByPlan('custom')">Custom</li>
                    </ul>
                  </th>
                  <th scope="col" style="color: #3f51b5">Air</th>
                  <th scope="col" style="color: #a13764">Weather</th>
                  <th scope="col" style="color: #2295c8">Water</th>
                  <th scope="col" style="color: #28a745">Pollen</th>
                  <th scope="col" style="color: #743d2b">Soil</th>
                  <th scope="col" style="color: #ffb347">Fire</th>
                  <th scope="col" style="color: #b2ad7f">All</th>
                  <th scope="col" style="color: #e91e63">Total</th>
                </tr>
              </thead>
              <tbody v-if="filteredUsers">
                <tr
                  v-for="users in filteredUsers"
                  v-bind:key="users._id"
                  class="ubuntu-medium"
                >
                  <td class="userData" @click="navigate(users.key)">
                    <div>{{ users.Total.name }}</div>
                    {{ users.Total.emailId }}
                    <div>
                      <small>{{ users.key }}</small>
                    </div>
                  </td>
                  <td class="plan">{{ getUserPlan(users) }}</td>
                  <td :class="userStatus === 'Air' ? actv : ''">
                    {{ users.Air ? users.Air.total : 0 }}
                  </td>
                  <td :class="userStatus === 'Weather' ? actv : ''">
                    {{ users.Weather ? users.Weather.total : 0 }}
                  </td>
                  <td :class="userStatus === 'Water_Vapour' ? actv : ''">
                    {{ users.Water_Vapour ? users.Water_Vapour.total : 0 }}
                  </td>
                  <td :class="userStatus === 'Pollen' ? actv : ''">
                    {{ users.Pollen ? users.Pollen.total : 0 }}
                  </td>
                  <td :class="userStatus === 'Soil' ? actv : ''">
                    {{ users.Soil ? users.Soil.total : 0 }}
                  </td>
                  <td :class="userStatus === 'Fire' ? actv : ''">
                    {{ users.Fire ? users.Fire.total : 0 }}
                  </td>
                  <td :class="userStatus === 'All' ? actv : ''">
                    {{ users.All ? users.All.total : 0 }}
                  </td>
                  <td :class="userStatus === 'Total' ? actv : ''">
                    {{ users.Total ? users.Total.total : 0 }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row d-flex justify-content-end">
          <div class="col-sm-9 offset-sm-1 text-center">
          <button
            class="btn btn-lg btn-link p-2 mr-2"
            @click="firstPage"
            :disabled="pageNumber === 1"
          >
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button
            class="btn btn-lg btn-link p-2 mr-2"
            @click="prevPage"
            :disabled="pageNumber === 1"
          >
            <i class="fas fa-angle-left"></i>
          </button>
          <span>Page {{ pageNumber }} of {{ pageCount }}</span>
          <button
            class="btn btn-lg btn-link p-2 ml-2"
            @click="nextPage"
            :disabled="pageNumber === pageCount"
          >
            <i class="fas fa-angle-right"></i>
          </button>
          <button
            class="btn btn-lg btn-link p-2 mr-2"
            @click="lastPage"
            :disabled="pageNumber === pageCount"
          >
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
          <div
            class="col-sm-2 btn btn-secondary mt-3"
            @click="generateReport(usageData)"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
            Download CSV
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "./sidebar";
import moment from "moment";
import Timeframe from "./Timeframe";
import Paramdrpdwn from "./Paramdrpdwn.vue";
// import { creatCsvFile, downloadFile, detectionClientType } from "download-csv";
import downloadCsv from "download-csv";
import _ from "underscore";

export default {
  mounted() {
    this.userStatus = this.$route.query.type ? this.$route.query.type : "Total";
    this.param = this.$route.query.type ? this.$route.query.type : "Total";
    this.filterObj = {
      custom:
        this.$route.query.custom && this.$route.query.custom == "true"
          ? true
          : false,
      days: this.$route.query.days ? this.$route.query.days : 1,
      from: this.$route.query.from || null,
      to: this.$route.query.to || null,
    };
    this.getUsageInDetail(
      this.plan,
      // this.$route.query.type || "Total",
      "Total",
      this.filterObj.from,
      this.filterObj.to
    );
  },
  data() {
    return {
      usageData: [],
      allUsers: [],
      nUserData: [],
      snu: false,
      summary: {},
      details: false,
      search: "",
      userStatus: "",
      param: "",
      sortby: "max",
      startDt: "",
      endDt: "",
      plan: "all",
      actv: "actvbtn",
      act: 1,
      day: 1,
      filterObj: { custom: false, days: 1 },
      pageNumber: 1,
      pageCount: "",
    };
  },
  computed: {
    filteredUsers() {
      {
        if (this.usageData) {
          return this.usageData.sort(this.compare).filter((user) => {
            return this.usageData.filter((user) => {
              if (
                user.Total.name
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                user.key.toLowerCase().includes(this.search.toLowerCase()) ||
                user.Total.emailId
                  .toLowerCase()
                  .includes(this.search.toLowerCase())
              )
                return user;
            });
          });
        }
      }
    },
  },
  components: {
    Sidebar,
    Timeframe,
    Paramdrpdwn,
  },
  methods: {
    getUsageInDetail(plan, param = "Total", start, end) {
      let paramArray = [
        "Air",
        "Weather",
        "Soil",
        "Pollen",
        "Fire",
        "Water_Vapour",
        "Total",
      ];
      // if (start && end) {
        const apiUri = `http://13.235.254.91:5000/dashboard/user-detailed-stats?start=${start}&end=${end}&sort=${param}&page=${this.pageNumber}`;
        // const apiUri = `http://localhost:3002/dashboard/user-detailed-stats?start=${start}&end=${end}&sort=${param}&page=${this.pageNumber}`;
        const options = {
          url: apiUri,
          method: "GET",
        };
        this.$http(options).then((result) => {
          this.pageCount = result.data.totalPages;
          if (plan === "all") {
            if (paramArray.includes(param)) {
              let usageData = result.data.mostApiCalls;
              this.usageData = usageData.sort((a, b) => {
                return b[param].total - a[param].total;
              });
            } else {
              this.usageData = [];
            }
          } else if (plan === "free") {
            if (paramArray.includes(param)) {
              this.usageData = result.data.mostApiCalls.filter((elm) => {
                return elm.Total.planId === "obalx7";
              });
            } else {
              this.usageData = [];
            }
          } else if (plan === "custom") {
            if (paramArray.includes(param)) {
              this.usageData = result.data.mostApiCalls.filter((elm) => {
                return elm.Total.planId === "obalx7" && elm.Total.limit > 100;
              });
            } else {
              this.usageData = [];
            }
          } else if (plan === "pay") {
            if (paramArray.includes(param)) {
              this.usageData = result.data.mostApiCalls.filter((elm) => {
                return elm.Total.planId === "hgdrvf";
              });
            } else {
              this.usageData = [];
            }
          }
          // else if (plan === "custom") {
          //   if (paramArray.includes(param)) {
          //     this.usageData = result.data.mostApiCalls.filter((elm) => {
          //       return elm.planId !== "hgdrvf" && elm.planId !== "obalx7";
          //     });
          //   } else {
          //     this.usageData = [];
          //   }
          // }
        });
      // }
    },
    filterByPlan(plan) {
      this.plan = plan;
      this.getUsageInDetail(
        this.plan,
        // this.param || "Total",
        "Total",
        this.filterObj.from,
        this.filterObj.to
      );
    },
    getUserPlan(user) {
      let planId = user.Total.planId;
      if (planId === "obalx7" && user.Total.limit == 100) {
        return "Free";
      } else if (planId === "obalx7" && user.Total.limit > 100) {
        return `Free - ${user.Total.limit}`;
      } else if (planId === "hgdrvf") {
        return "Pay as you go";
      } else {
        return "Custom";
      }
    },
    setSelected(param) {
      this.userStatus = param;
      this.param = param;
      this.getUsageInDetail(
        this.plan,
        // param,
        "Total",
        this.filterObj.from,
        this.filterObj.to
      );
    },
    navigate(key) {
      this.$router.push({
        path: `/user/${key}/info`,
        query: {
          custom: true,
          days: this.$route.query.days,
          from: this.$route.query.from,
          to: this.$route.query.to,
          parent_route: "apiusage",
        },
      });
    },
    tm(recentTm) {
      if (recentTm) return moment(recentTm).format("DD-MM-YYYY hh:mm A");
      else return "";
    },
    backClicked() {
      this.$emit("setUsage");
    },
    setActive(num) {
      this.act = num;
    },
    setTimeFrame(num) {
      this.filterBy(num);
    },
    filterBy(d) {
      let num = d.num;
      this.startDt = d.startDt;
      this.endDt = d.endDt;
      this.day = d.day;
      this.getUsageInDetail(
        this.plan,
        // this.userStatus,
        "Total",
        this.startDt,
        this.endDt
      );
    },
    dateChanged(f) {
      this.filterObj.custom = f.custom;
      this.filterObj.days = f.num;
      this.filterObj.from = f.startDt;
      this.filterObj.to = f.endDt;
      this.$router.push({
        path: `/apiusers?type=${this.$route.query.type}`,
        query: this.filterObj,
      });
    },
    setPrevRoute() {
      this.$router.go(-1);
    },
    compare(a, b) {
      if (this.sortby === "max") {
        if (a.total < b.total) {
          return 1;
        }
        if (a.total > b.total) {
          return -1;
        }
        return 0;
      } else if (this.sortby === "min") {
        if (a.total < b.total) {
          return -1;
        }
        if (a.total > b.total) {
          return 1;
        }
        return 0;
      } else if (this.sortby === "latest") {
        if (a.recentApiCall < b.recentApiCall) {
          return 1;
        }
        if (a.recentApiCall > b.recentApiCall) {
          return -1;
        }
        return 0;
      }
    },
    generateReport(data) {
      let d = data.map((elm) => {
        let newElm = {
          user: elm.Total.name,
          email: elm.Total.emailId,
          key: elm.key,
          plan: elm.Total ? this.getUserPlan(elm) : "",
          air: elm.Air ? elm.Air.total : 0,
          weather: elm.Weather ? elm.Weather.total : 0,
          water: elm.Water_Vapour ? elm.Water_Vapour.total : 0,
          pollen: elm.Pollen ? elm.Pollen.total : 0,
          soil: elm.Soil ? elm.Soil.total : 0,
          fire: elm.Fire ? elm.Fire.total : 0,
          all: elm.All ? elm.All.total : 0,
        };
        // elm.plan = this.getUserPlan(elm.Total.planId);
        return newElm;
      });
      downloadCsv(d);
    },
    nextPage() {
      this.pageNumber++;
      this.getUsageInDetail(this.plan, "Total", this.filterObj.from, this.filterObj.to)
    },
    prevPage() {
      this.pageNumber--;
      this.getUsageInDetail(this.plan, "Total", this.filterObj.from, this.filterObj.to)
    },
    firstPage() {
      this.pageNumber = 1;
      this.getUsageInDetail(this.plan, "Total", this.filterObj.from, this.filterObj.to)
    },
    lastPage() {
      this.pageNumber = this.pageCount;
      this.getUsageInDetail(this.plan, "Total", this.filterObj.from, this.filterObj.to)
    },
    resetPageParams() {
      this.pageNumber = 1;
      this.pageCount = 1;
    },
    countOfPages(usercount) {
      return Math.ceil(usercount / 20);
    },
  },
  watch: {
    $route() {
      this.filterObj = {
        custom:
          this.$route.query.custom && this.$route.query.custom == "true"
            ? true
            : false,
        days: this.$route.query.days ? this.$route.query.days : 1,
        from: this.$route.query.from || null,
        to: this.$route.query.to || null,
      };
      this.pageNumber = 1;
      this.getUsageInDetail(
        this.plan,
        // this.param || "Total",
        "Total",
        this.filterObj.from,
        this.filterObj.to
      );
    },
  },
};
</script>

<style scoped>
.val {
  font-size: 0.9rem;
}
.fa-angle-down:hover {
  color: #2295c8;
  transform: scale(1.3);
}
.actvbtn {
  color: #3498db;
}
.apittl {
  font-family: Ubuntu;
  color: rgba(59, 59, 59, 0.8);
  font-weight: 500;
  font-size: 1.6rem;
}
.plan {
  text-transform: capitalize;
}

#tu {
  color: #3f51b5;
}
#tapi {
  color: #e91e63;
}
#nu {
  color: #28a745;
}
.srchfilter {
  background-color: rgba(0, 123, 255, 0.5);
}
.userData {
  cursor: pointer;
}
a {
  text-decoration: none;
}
.dropdown-menu {
  color: grey;
  cursor: pointer;
}
li {
  font-size: 0.9rem;
}
li:hover {
  color: blue;
}
</style>